export const SUPPORT_EMAIL = 'support@vantis-health.com';
